import $ from 'jquery';
import _ from 'lodash-es';

// Set a body variable
window.$body = $('body');

// Add/Remove classes to header element on scroll to resize elements.
function scrollz() {
    const $jump = $('#jump');
    const $window = $(window);
    let scrolled = false;

    $(window).on('scroll', () => {
        scrolled = true;
    });

    const timeout = setInterval(() => {
        if (scrolled) {
            scrolled = false;
            if ($window.scrollTop() >= 200) {
                $jump.fadeIn();
            } else {
                $jump.fadeOut();
            }
        }
    }, 100);

    $jump.on('click', () => {
        $('html, body').animate({
            scrollTop: 0,
        }, 800);
    });
}

// Add pretty title on scroll for ark objects
function beaconize() {
    const $beacon = $('#ark-beacon');
    const $window = $(window);
    let scrolled = false;

    $(window).on('scroll', () => {
        scrolled = true;
    });

    const timeout = setInterval(() => {
        if (scrolled) {
            scrolled = false;
            if ($window.scrollTop() >= 100) {
                $beacon.removeClass('hidden');
                $beacon.addClass('show');
            } else {
                $beacon.removeClass('show');
                $beacon.addClass('hidden');
            }
        }
    }, 100);
}

// Detect if the device is capable of touch
function isTouchDevice() {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}

// Add bootstrap tooltips to items with the -toggle="tooltip" data attribute
// Tooltip called on body with selector to initialize dynamic elements (charts)
function doTooltips() {
    if (isTouchDevice()) {
        window.$body.tooltip({
            selector: '[data-toggle="touch-tooltip"]',
            container: 'body',
        });
    } else {
        window.$body.tooltip({
            selector: '[data-toggle="tooltip"], [data-toggle="touch-tooltip"]',
            trigger: 'hover',
            container: 'body',
        });
    }
}

// Add bootstrap tooltips to items with the -toggle="tooltip" data attribute
function doPopovers() {
    if (isTouchDevice()) {
        $('[data-toggle="touch-popover"]').popover({
            container: 'body',
        });
    } else {
        $('[data-toggle="popover"], [data-toggle="touch-popover"]').popover({
            container: 'body',
        });
    }
}

// Do a pretty show/hide slide effect on primary nav.
function prettyDropdowns() {
    $('.dropdown--mega').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true)
            .slideDown();
    }).on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true)
            .slideUp();
    });
}

// animate the search icon on search form submits to indicate 'thinking'
function animateSearchIcon() {
    $('form.search').on('submit', function () {
        $(this).find('.fa-search').removeClass('fa-search').addClass('fa-circle-o-notch fa-spin');
    });
}

// Hide tooltips on items with both dropdowns and tooltips on init
function dropdownRemovesTip() {
    $('.tip-down').on('show.bs.dropdown', () => {
        $('.tip-down-target').tooltip('hide');
    });
}

// Provide a scroll effect and list length updates for list.js searches on med-res/short-displays
// so that the user is aware of state change
function scrollToListJSResults() {
        $('.list__filter').on('submit', function (e) {
            e.preventDefault();

            const $this = $(this);
            const target = $this.attr('data-target');

            $('html, body').animate({
                scrollTop: $(target).offset().top,
            }, 200);
        });

        $('.list__jumper').on('click', function () {
            const $this = $(this);
            const target = $this.attr('data-target');

            $('html, body').animate({
                scrollTop: $(target).offset().top,
            }, 200);
        });
}

// Do a bootstrap popover for links to metadata record
function showThumbnailMeta() {
    $('[rel=show-meta]').popover({
                            html: true,
                            placement: 'bottom',
                            trigger: 'hover',
                            content() {
                                const targetId = $(this).attr('data-target');
                                return $(targetId).html();
                            },
    });
}

// Add a css animation effect to any item with a .reveal class
function revealButtons() {
    $('.reveal').on('click', function () {
        const $this = $(this);
        const animation = $this.attr('data-animation');

        $this.siblings('.btn').show().addClass(animation);
    });
}

// On the homepage, get a random header image and associated info.
function createRandomHomepageFeature() {
    if ($('#portal-home').length) {
        $.getJSON('/media/assets/public/images/pth/home/banners/manifest.json?v=3', (data) => {
            const classes = $('#top').attr('class').split(' ');
            const bgClass = _.find(classes, o => _.startsWith(o, 'search__bg--'));
            const bgName = _.last(bgClass);
            const content = _.find(data.features, o => _.startsWith(o.file, bgName));
            $('#attribution-src').text(content.visibleText).attr('href', content.path);
            $('#bg-attribution').show().addClass('animate__animated animate__fadeIn');
        });
    }
}

// Show/Hide long search results descriptions
function toggleDrawer() {
  $('[data-toggle=offcanvas]').click(() => {
    $('.row-offcanvas').toggleClass('active');
  });
}

function whatsNew() {
    if ($('#explore-partners, #explore-collections').length) {
        const d = new Date();
        const m = d.getMonth();

        d.setMonth(d.getMonth() - 10);
        if (d.getMonth() == m) d.setDate(0);
        d.setHours(0, 0, 0);
        const lastMonth = (d / 1000 | 0);

        $('.action-card--message').each(function () {
            const $this = $(this);
            const createdOn = $this.data('created');
            if (createdOn >= lastMonth) {
                $this.removeClass('hidden');
            }
        });
    }
}

export {
    revealButtons,
    scrollz,
    beaconize,
    doTooltips,
    doPopovers,
    prettyDropdowns,
    dropdownRemovesTip,
    animateSearchIcon,
    showThumbnailMeta,
    scrollToListJSResults,
    createRandomHomepageFeature,
    toggleDrawer,
    whatsNew,
};
